import { Card, Divider, Grid, Tooltip } from "@mui/material";
import { BtnClear, BtnExportExcel, BtnSearch } from "components/Button/ButtonAll";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FnAxios, FnDialog } from "utilities/utilities";
import CheckIcon from '@mui/icons-material/Check';
import { GridColumnGroupingModel } from '@mui/x-data-grid';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import IconButton from '@mui/material/IconButton';
import DialogPreview from "components/DialogPreview/DialogPreview";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { EnumMasterData } from "enum/enum";

const EmploymentSummary = () => {
    const arrPin = ['nNo', 'sFullName', 'sPosition'];
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const [loadingTable, setLoadingTable] = useState(false);
    const [arrSummary, setarrSummary] = useState([]);
    const [dataColumSummary, setDataColumnSummary] = useState<any>([]);
    const [arrChildren, setArrChildren] = useState<any>([]);
    const [sHeadName, setHeadName] = useState("");
    const [loadingTableRemark, setLoadingTableRemark] = useState(false);
    const [isOpenRemarkModal, setOpenRemarkModal] = useState(false);
    const [lstUser, setLstUser] = useState([]);
    const [sDocName, setDocName] = useState([]);
    const [isOpenFile, setIsOpenFile] = useState(false);
    const [arrModalFile, setArrModalFile] = useState([]);
    const [lstRemarkNoPage, setLstRemark] = useState([]);
    const [lstSummaryNoPage, setLstSummary] = useState([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "nNo",
        sSortDirection: "asc"
    });
    const [dataRowRemark, setDataRowRemark] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sWorkDate",
        sSortDirection: "asc"
    });

    const currentDate = new Date(); // Get the current date
    const dYear = new Date(currentDate.getFullYear(), 0, 1);
    const dMonth = new Date(currentDate.getFullYear(), (currentDate.getMonth() + 1), 0);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            objYear: dYear,
            objMonth: dMonth,
        } as any,
    });

    const dataSummary: any = [
        {
            field: 'nNo',
            headerName: 'ลำดับ',
            headerAlign: 'center',
            width: 40,
            sortable: true,
            align: "center",
        },
        {
            field: 'sFullName',
            headerName: 'ชื่อ - นามสกุล',
            headerAlign: 'center',
            minWidth: 240,
            sortable: true,
            align: "left",
        },
        {
            field: 'sPosition',
            headerName: 'ตำแหน่ง',
            headerAlign: 'center',
            minWidth: 250,
            sortable: true,
            align: "left",
        }
    ];

    //merge tabel head
    const columnGroupingModel: GridColumnGroupingModel = [
        {
            groupId: "sMonth",
            headerName: sHeadName,
            description: "",
            children: arrChildren,
            headerAlign: "center",
        },
        {
            groupId: "sGroupLeaveType",
            headerName: "รวม (จำนวนวัน)",
            description: "",
            children: [{ field: "nCountSick" }, { field: "nCountLeave" }, { field: "nCountAbsent" }, { field: "nCountLate" }, { field: "nCountDuty", }],
            headerAlign: "center",
        },
    ];

    //remark talbe
    const dataSummaryRemark: any = [
        {
            field: 'sWorkDate',
            headerName: 'วันปฎิบัติงาน  ',
            headerAlign: 'center',
            width: 100,
            sortable: true,
            align: "center",
        },
        {
            field: 'sStartWorkTime',
            headerName: 'เวลาเข้า',
            headerAlign: 'center',
            minWidth: 100,
            sortable: true,
            align: "center",
        },
        {
            field: 'sEndWorkTime',
            headerName: 'เวลาออก',
            headerAlign: 'center',
            minWidth: 100,
            sortable: true,
            align: "center",
        },
        {
            field: 'sRemark',
            headerName: 'หมายเหตุ',
            headerAlign: 'center',
            minWidth: 250,
            sortable: true,
            align: "left",
        },
        {
            field: 'objFile',
            headerName: 'ไฟล์แนบ',
            headerAlign: 'center',
            minWidth: 100,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    item.row.sFilePath != undefined && item.row.sFilePath !== "" ?
                        <IconButton size="small" onClick={() => handleViewFile(item.row)}>
                            <InsertDriveFileIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                        :
                        null
                );
            }
        }
    ];

    const getFormInitial = () => {
        AxiosFn.Get(`EmploymentSummary/GetFormInitial`, {}, (result) => {
            setLstUser(result.objResult.lstUserFilter);
        });
    }

    const getTable = (p: PaginationInterface) => {
        setLoadingTable(true);

        let ObjForm = form.getValues();
        let nSetYear = ObjForm.objYear === null ? dYear.valueOf() : ObjForm.objYear.valueOf();
        let nSetMonth = ObjForm.objMonth === null ? dMonth.valueOf() : ObjForm.objMonth.valueOf();

        let param = {
            ...p,
            lstUser: ObjForm.lstUser || [],
            nYear: nSetYear,
            nMonth: nSetMonth,
        }

        AxiosFn.Post(`EmploymentSummary/GetTable`, param, (result) => {
            setDataRow({
                ...p,
                arrRows: result.lstSummary ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

            setLoadingTable(false);
            setarrSummary(result.objResult.lstDate);
            setLstSummary(result.objResult.lstSummaryEmployee);
        });
    };

    const handleExportExcel = () => {
        DialogFn.BlockUI();
        let sFileName = `สรุปข้อมูลการลงทะเบียนเข้าออก-งาน.xlsx`

        let ObjForm = form.getValues();
        let nSetYear = ObjForm.objYear ? ObjForm.objYear.valueOf() : null;
        let nSetMonth = ObjForm.objMonth ? ObjForm.objMonth.valueOf() : null;

        let param = {
            lstSummary: lstSummaryNoPage,
            lstDate: arrSummary,
            lstUser: ObjForm.lstUser || [],
            nYear: nSetYear,
            nMonth: nSetMonth,
        }

        AxiosFn.DowloadFileBlob(`EmploymentSummary/onExportExcel`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        });
    }

    const getTableRemark = (p: PaginationInterface, sUserID?: string, nAttendanceID?: number) => {
        setLoadingTableRemark(true);

        let ObjForm = form.getValues();
        let nSetYear = ObjForm.objYear === null ? dYear.valueOf() : ObjForm.objYear.valueOf();
        let nSetMonth = ObjForm.objMonth === null ? dMonth.valueOf() : ObjForm.objMonth.valueOf();

        let param = {
            ...p,
            sUserID: sUserID,
            nAttendanceID: nAttendanceID,
            nYear: nSetYear,
            nMonth: nSetMonth,
        }

        AxiosFn.Post(`EmploymentSummary/GetTableRemark`, param, (result) => {
            setDataRowRemark({
                ...p,
                arrRows: result.lstRemark ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

            setLoadingTableRemark(false);
            setOpenRemarkModal(true);
            setLstRemark(result.objResult.lstRemark);
        });
    };

    const handleViewFile = (objRow) => {
        let param = {
            nAttendanceID: objRow.nAttendanceID
        }
        setDocName(objRow.sTitle);
        AxiosFn.Post(`EmploymentSummary/GetPDF`, param, (result) => {
            DialogFn.UnBlockUI();
            setIsOpenFile(true);
            setArrModalFile(result.lstFilePDF);
        });
    };

    const handleClearFilter = () => {
        form.setValue("lstUser", []);
        form.setValue("objYear", null);
        form.setValue("objMonth", null);

        form.clearErrors("lstUser");
        form.clearErrors("objYear");
        form.clearErrors("objMonth");
    }

    useEffect(() => {
        const dataColumn = [...dataSummary,
        //month column
        ...arrSummary.map((o) => {
            setHeadName(o.label);
            return {
                field: "Date_" + o.value,
                headerName: o.value,
                headerAlign: 'center',
                width: 50,
                sortable: false,
                cellClassName: o.sValue === "Y" ? 'holiday-bg' : "",
                align: "center",
                renderCell: (item) => {
                    const itemData = item.row.lstSmrMonth.find(s => s.sMonthName === o.label && +(s.sWorkDay) === o.value);
                    const isHaveType = itemData != null;
                    return (
                        isHaveType ?
                            <Tooltip title={itemData.sStatuNameFull}>
                                <span style={{ color: ((itemData.nStatusAbbr === EnumMasterData.Absent|| itemData.nStatusAbbr === EnumMasterData.HalfAbsent) ? "red" : "#DA0000 !important") }}>
                                    {itemData.sStatusAbbr ?? <CheckIcon />}
                                </span>
                            </Tooltip>
                            :
                            null
                    );
                }
            }
        }),

        //ลาป่วย
        {
            field: "nCountSick",
            headerName: "ลาป่วย",
            headerAlign: 'center',
            width: 75,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountSick !== 0 ? item.row.nCountSick : null}
                    </div>
                );
            }
        },
        //ลา
        {
            field: "nCountLeave",
            headerName: "ลา",
            headerAlign: 'center',
            width: 75,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountLeave !== 0 ? item.row.nCountLeave : null}
                    </div>
                );
            }
        },
        //ขาด
        {
            field: "nCountAbsent",
            headerName: "ขาด",
            headerAlign: 'center',
            width: 75,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountAbsent !== 0 ? item.row.nCountAbsent : null}
                    </div>
                );
            }
        },
        //สาย
        {
            field: "nCountLate",
            headerName: "สาย",
            headerAlign: 'center',
            width: 75,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountLate !== 0 ? item.row.nCountLate : null}
                    </div>
                );
            }
        },
        //ไปราชการ
        {
            field: "nCountDuty",
            headerName: "ไปราชการ",
            headerAlign: 'center',
            width: 75,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountDuty !== 0 ? item.row.nCountDuty : null}
                    </div>
                );
            }
        },
        //remark column
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: 'center',
            width: 80,
            sortable: false,
            align: "center",
            renderCell: (item) => {
                return (
                    item.row.isRemark || item.row.isFile ?
                        <IconButton color="primary" aria-label="add to shopping cart" onClick={() => getTableRemark(dataRowRemark, item.row.sUserID, item.row.nAttendanceID)}>
                            <AnnouncementIcon />
                        </IconButton>
                        :
                        null
                );
            }
        },
        ];
        setDataColumnSummary(dataColumn)

        let arrChildren = [];
        dataColumn.forEach(f => {
            if (f.field.includes("Date_")) {
                arrChildren.push({ field: f.field })
            }
        });

        setArrChildren(arrChildren);
    }, [arrSummary]);

    useEffect(() => {
        getFormInitial();
        getTable(dataRow)
    }, [])

    return (
        <FormProvider {...form}>
            <Grid container>
                {/* filter */}
                <Grid item xs={12} md={12} container spacing={1} justifyItems={'flex-start'} justifyContent={'flex-end'} sx={{ mt: "2%" }}>
                    <Grid item xs={12} md={10} container spacing={2} justifyItems={'flex-start'} justifyContent={'end'}>
                        <FormProvider {...form}>
                            <Grid item xs={12} md={6}>
                                <MultipleSelectItem
                                    id={"lstUser"}
                                    name={"lstUser"}
                                    label={"ชื่อ - นามสกุล"}
                                    required={false}
                                    options={lstUser}
                                    limitTag={1}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <DatePickerItem
                                    name={`objYear`}
                                    id={`objYear`}
                                    label={"ปี"}
                                    IsYearPicker
                                    required={false}
                                />
                            </Grid>
                            <Grid item xs={12} md={2.5}>
                                <DatePickerItem
                                    name={`objMonth`}
                                    id={`objMonth`}
                                    label={"เดือน"}
                                    IsMonthPicker
                                    required={false}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.5} container spacing={1} justifyItems={'flex-start'} justifyContent={'end'}>
                                <Grid item>
                                    <BtnClear id={'btnClearSearchAll'} IsCircleWithOutText={true} onClick={() => { handleClearFilter(); }} /> {/* icon={<ClearIcon />} */}
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={true}
                                        onClick={() => { getTable(dataRow); }}
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </Grid>

                    <Grid item xs={12} md={2} justifyContent={"flex-end"} sx={{ display: "flex" }}>
                        <BtnExportExcel id={"expSummaryEmployment"} tooltiptxt='Export to Excel File' onClick={() => handleExportExcel()} />
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: "2%" }}>
                    <DataGrid
                        sTableID='tableSummaryEmployee'
                        columns={dataColumSummary}
                        rows={dataRow}
                        isLoading={loadingTable}
                        onLoadData={getTable}
                        isShowCheckBox={false}
                        experimentalFeatures={{ columnGrouping: true }} //Grouping Header Column
                        columnGroupingModel={columnGroupingModel} //Grouping Header Column
                        isPin={false}
                        isHiddenToolHead
                        arrPin={arrPin}
                        isDisableColumnMenu={true}
                    />
                </Grid>

                {/* remark */}
                <DialogPreview
                    IsOpen={isOpenRemarkModal}
                    IsBackdropClick={false}
                    onClose={() => setOpenRemarkModal(prev => !prev)}
                    JsxDialogAction
                    CloseSave={false}
                    Close={false}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={'หมายเหตุ/ไฟล์แนบ'}
                >
                    <Grid item xs={12} sx={{ mt: "2%" }}>
                        <DataGrid
                            sTableID='tableSummary'
                            columns={dataSummaryRemark}
                            rows={dataRowRemark}
                            isLoading={loadingTableRemark}
                            onLoadData={getTableRemark}
                            isShowCheckBox={false}
                            isHiddenToolHead
                        />
                    </Grid>
                </DialogPreview>

                {/* Remark File */}
                <DialogPreview
                    IsOpen={isOpenFile}
                    IsBackdropClick={false}
                    onClose={() => setIsOpenFile(prev => !prev)}
                    JsxDialogAction
                    CloseSave={false}
                    Close={false}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={'หมายเหตุ/ไฟล์แนบ'}
                >
                    <Grid item xs={12}>
                        <Card sx={{ padding: 2 }}>
                            {arrModalFile.length > 0 && arrModalFile.map((m) => (
                                <Grid key={m.sFilePath} container mt={1}>
                                    <Grid item xs={12}>
                                        <a
                                            href={
                                                process.env.REACT_APP_API_URL +
                                                "UploadFile/" +
                                                m.sFilePath
                                            }
                                            download
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                container
                                                justifyContent={"space-between"}
                                            >
                                                <Grid item key={m.sFileName}>
                                                    {m.sFileName}
                                                </Grid>
                                                <Grid item key={m.sFileName}>
                                                    <IconButton size="small">
                                                        <DownloadIcon color={"primary"} />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </a>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Card>
                    </Grid>
                </DialogPreview>
            </Grid>
        </FormProvider>
    );
}

export default EmploymentSummary;